import { MessagePageEvent } from "@/User/Constants/twilio";
import { useTwilioClientContext } from "@/User/Contexts/TwilioClientContext";
import { CONVERSATION_PAGE_SIZE } from "@/utils";
import { usePage } from "@inertiajs/react";
import { useCallback, useEffect, useState } from "react";
import { updateFranchiseReadById } from "@/User/Services/UserScoutService";

export const useTwilioChat = () => {
    const { conversation: dbConversation, userScout, auth: { user } } = usePage().props;
    const { twilioClient } = useTwilioClientContext();

    const [clientInited, setClientedInited] = useState(false);
    const [initialChat, setInitialChat] = useState(true);
    const [conversation, setConversation] = useState(null);
    const [messages, setMessages] = useState([]);
    const [paginator, setPaginator] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [franchiseRead, setFranchiseRead] = useState(Boolean(userScout?.data.is_franchise_read));

    const getConversationData = async () => {
        if (!dbConversation) {
            conversation && setConversation(null);
            return;
        }

        if (conversation && dbConversation.converstion_id === conversation.sid) {
            return;
        }

        setInitialChat(true);
        const twilioConversation = await twilioClient.getConversationBySid(dbConversation.conversation_id);

        const messages = await twilioConversation.getMessages(CONVERSATION_PAGE_SIZE);

        setConversation(twilioConversation);
        setMessages([
            ...messages.items.reverse()
        ]);
        setPaginator(messages);
        setHasMore(messages.hasPrevPage);
        setInitialChat(false);
    };

    const setAllMessageRead = async () => {

        if (!conversation) {
            return;
        }

        await conversation.setAllMessagesRead();
    };

    const fetchMore = async () => {
        setLoadingMore(true);
        if (!paginator) {
            setLoadingMore(false);
            return;
        }
        const result = await paginator?.prevPage();
        if (!result) {
            setLoadingMore(false);
            return;
        }

        setMessages([
            ...messages,
            ...result.items.reverse()
        ]);
        setPaginator(result);
        setLoadingMore(false);
        setHasMore(result.hasPrevPage);
    };

    const handleMessageAdded = useCallback((e) => {
        const newMessage = e.detail?.message;

        if (dbConversation?.conversation_id !== newMessage.conversation.sid) {
            return;
        }

        setAllMessageRead();
        setFranchiseRead((oldFlg) => {
            let newFlg = oldFlg;
            const fromUser = newMessage?.state.author === user?.data.uid;
            if (!fromUser) {
                newFlg = true;
            } else if (fromUser && oldFlg) {
                updateFranchiseReadById({ id: userScout?.data.id });
                newFlg = false;
            }

            return newFlg;
        });

        setMessages((oldValues) => {
            oldValues.unshift(newMessage);

            return [...oldValues];
        });
    }, [conversation, dbConversation, messages, setMessages, franchiseRead, setFranchiseRead]);

    useEffect(() => {
        twilioClient && !clientInited && setClientedInited(true);
    }, [twilioClient]);


    useEffect(() => {
        if (clientInited) {
            getConversationData();
        }
    }, [clientInited, dbConversation]);

    useEffect(() => {
        setFranchiseRead(Boolean(userScout?.data.is_franchise_read));
    }, [userScout]);

    /***** Handle event have new message ******/
    useEffect(() => {
        if (conversation) {
            setAllMessageRead();
        }

        window.addEventListener(MessagePageEvent.messageAdded, handleMessageAdded);

        return () => {
            window.removeEventListener(MessagePageEvent.messageAdded, handleMessageAdded);
        };
    }, [conversation]);

    return { initialChat, conversation, messages, paginator, hasMore, fetchMore, loadingMore, setAllMessageRead, setConversation };
};
